"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.knowledge.exceeded': 'Límite de entradas de conocimiento alcanzado. Actualice su plan para agregar más entradas.',
    'limits.knowledge.limitReached': 'Límite de conocimiento: {limit} (actualizar para más)',
};
